
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nashe-portfolio",
      function () {
        return require("private-next-pages/nashe-portfolio/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nashe-portfolio"])
      });
    }
  